export default ($parse) => ({
    require: 'ngModel',
    restrict: 'A',
    link(scope, element, attr, ctrl) {
        var min = parseFloat($parse(attr.min)(scope));
        var max = parseFloat($parse(attr.max)(scope));
        function inputValue(val) {
            if (val) {
                var digits = val.replace(/[^0-9.]/g, '');

                if (digits !== val) {
                    ctrl.$setViewValue(digits);
                    ctrl.$render();
                }
                return parseFloat(digits);
            }
            return undefined;
        }
        ctrl.$parsers.push(inputValue);
    }
});